import { PRODUCT_TYPES } from '../../constants';
import { TWELVE_WEEK_SHORTLIST } from '../../../src_new/infrastructure/routing/constants';

export const routes = {
  root: '/',
  base: '/e_recruiting_talent_service',
  oldBase: '/e_recruiting_sourcing_service',
  signup: '/signup',
  login: '/login',
  oldBriefingForm: `/briefing/form`,
  briefingLonglistForm: `/${PRODUCT_TYPES.longlist}/briefing/form`,
  briefingShortlistForm: `/${PRODUCT_TYPES.shortlist}/briefing/form`,
  briefingLonglistFormStep: `/${PRODUCT_TYPES.longlist}/briefing/form/:step`,
  briefingShortlistFormStep: `/${PRODUCT_TYPES.shortlist}/briefing/form/:step`,
  briefingBadFormStep: `/:type/briefing/form/:step`,
  briefingLonglistFormStep1: `/${PRODUCT_TYPES.longlist}/briefing/form/step_1`,
  briefingShortlistFormStep1: `/${PRODUCT_TYPES.shortlist}/briefing/form/step_1`,
  briefingLonglistFormStep2: `/${PRODUCT_TYPES.longlist}/briefing/form/step_2`,
  briefingShortlistFormStep2: `/${PRODUCT_TYPES.shortlist}/briefing/form/step_2`,
  briefingsDashboard: '/briefings',
  briefingDetail: '/briefings/:briefingId',
  candidateShortlist: `/briefings/:briefingId/shortlist/`,
  candidateShortlistProfile: `/briefings/:briefingId/shortlist/:candidateId`,
  candidateLonglistProfile: `/briefings/:briefingId/longlist/:candidateId`,
  onboarding: '/onboarding',
  printAllCandidates: `/briefings/:briefingId/shortlist/print/`,
  printAllCandidatesV2: `/briefings/:briefingId/shortlist-v2/print/`,
  candidateShortlistV2: `/briefings/:briefingId/shortlist-v2/`,
  productSelection: '/briefing/form/product',
  longlist: '/briefings/:briefingId/longlist',
  newBriefingForm: `/new/briefing/form`,
  newBriefingDetails: `/new/briefings/:briefingId`,
  newReportList: `/briefings/:briefingId/reports/`,
  newReportDetails: `/briefings/:briefingId/reports/:reportId`,
} as const;

// ROUTE HELPERS
// policy: default product type is Shortlist
export const step1Route = (prodType: PRODUCT_TYPES, duration?: string) => {
  if (prodType === PRODUCT_TYPES.longlist)
    return routes.briefingLonglistFormStep1;

  if (duration && duration === TWELVE_WEEK_SHORTLIST) {
    return `${routes.briefingShortlistFormStep1}?duration=${duration}`;
  }

  return routes.briefingShortlistFormStep1;
};

export const step2Route = (prodType: PRODUCT_TYPES, duration?: string) => {
  if (prodType === PRODUCT_TYPES.longlist)
    return routes.briefingLonglistFormStep2;

  if (duration && duration === TWELVE_WEEK_SHORTLIST) {
    return `${routes.briefingShortlistFormStep2}?duration=${duration}`;
  }

  return routes.briefingShortlistFormStep2;
};

const productLists = {
  shortlist: routes.candidateShortlist,
  longlist: routes.longlist,
};

type GoToProductListArgs = {
  briefingId: string;
  prodType: PRODUCT_TYPES;
};

export const goToProductList = ({
  briefingId,
  prodType,
}: GoToProductListArgs): string => {
  return productLists[prodType].replace(':briefingId', briefingId);
};
